import React from 'react';
import { Card, Button, Tooltip } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { t } from '../../i18n/i18n';

const NodeCard = ({ template, onDragStart, onAddToCanvas }) => {
  const handleDragStart = (e) => {
    e.dataTransfer.setData('application/json', JSON.stringify(template));
    e.dataTransfer.effectAllowed = 'copy';
    if (onDragStart) {
      onDragStart(e, template);
    }
  };

  const handleClick = () => {
    if (onAddToCanvas) {
      onAddToCanvas(template);
    }
  };

  const handleAddButtonClick = (e) => {
    e.stopPropagation();
    if (onAddToCanvas) {
      onAddToCanvas(template);
    }
  };

  return (
    <Card
      size="small"
      className="node-template-card"
      draggable
      onDragStart={handleDragStart}
      onClick={handleClick}
      hoverable
    >
      <div className="node-card-content">
        <div className="node-icon" style={{ backgroundColor: template.color }}>
          <img
            className="node-icon"
            src={`data:image/svg+xml;base64,${btoa(template.icon)}`}
            alt=""
          />
        </div>
        <div className="node-info">
          <div className="node-name">{t(template.name)}</div>
          <div className="node-description">{t(template.description)}</div>
        </div>
        <Tooltip title={t('ALKYMATION_ADD_TO_CANVAS')}>
          <Button type="text" icon={<PlusOutlined />} size="small" onClick={handleAddButtonClick} />
        </Tooltip>
      </div>
    </Card>
  );
};

export default NodeCard;
